import React, { useEffect, useContext, useState } from 'react';
import {
  Grid,
  Checkbox,
  Tooltip,
  Typography,
} from '@nextiva/next-ui-components';
import clsx from 'clsx';
import { Avatar } from 'components';
import { TeamSMSAdd, TeamSMSAssigned } from 'components/SvgIcon';
import { FeatureContext } from 'components/AccessResolvers/featureContext';
import { TEAM_SMS } from 'constants/features';

import { CreateTeamContext, actionTypes } from '../../createTeamContext';

import classes from './m-user-row.scss';

const UserAvatar = React.memo(({ firstName, lastName }) => {
  return (
    <Avatar
      firstName={firstName}
      lastName={lastName}
      className="Avatar_outer"
      textClassName="Avatar_inner"
    />
  );
});

export const UserRow = ({ user, style = {}, handleClick }) => {
  const [checked, setChecked] = useState(false);
  const [hasTeamSMSLicense, setTeamSMSLicense] = useState(false);
  const {
    featureState: { teamsSMSLicensing },
  } = useContext(FeatureContext);
  const { firstName, lastName, email } = user;

  const {
    dispatch,
    createTeamState: { selectedUserList, userProductFeaturesMap },
    smsEnabled,
  } = useContext(CreateTeamContext);

  useEffect(() => {
    const userChecked = selectedUserList.some(
      (selectedUser) => selectedUser.email === email,
    );
    setChecked(userChecked);
    if (userChecked && userProductFeaturesMap[user.nextivaUUID]?.products) {
      setTeamSMSLicense(
        !!userProductFeaturesMap[user.nextivaUUID].products
          ?.find((product) => product.product === 'SMS')
          ?.features.find((feature) => feature.name === TEAM_SMS),
      );
    }
  }, [user, selectedUserList]);

  const checkboxHandler = () => {
    dispatch({
      type: actionTypes.SET_USER_CHECKED_STATE,
      email,
    });
  };

  return (
    <div
      className={clsx('m-table-row', 'm-table-row--full-width')}
      style={style}
      data-testid="PlatformAdminUI-TeamsLink-UserRow"
    >
      <Grid container spacing={0} alignItems="center">
        <div
          className={classes.row__usercheckbox}
          data-testid="PlatformAdminUI-TeamsLink-UserRow-CheckBox"
        >
          <Checkbox
            id={email}
            onChange={checkboxHandler}
            checked={checked}
            data-test-checked={checked}
            data-testid="PlatformAdminUI-UserRow-Checkbox"
          />
        </div>
        <Grid item xs={6}>
          <Grid container spacing={0} className={classes.row__useritem}>
            <UserAvatar firstName={firstName} lastName={lastName} />
            <Grid item xs={9}>
              <Grid item xs={12}>
                <span
                  className={classes.row__useritem__name}
                  data-testid="PlatformAdminUI-TeamsLink-UserRow-ItemName"
                >
                  {firstName} {lastName}
                </span>
              </Grid>
              <Grid item xs={12}>
                <span
                  className={clsx('Caption', classes.row__useritem__email)}
                  data-testid="PlatformAdminUI-TeamsLink-UserRow-Email"
                >
                  {email}
                </span>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {teamsSMSLicensing &&
          smsEnabled &&
          checked &&
          (hasTeamSMSLicense ? (
            <Grid item xs={4} data-testid="PlatformAdminUI-TableHeader-ToolTip">
              <span className={classes.row__teamAssigned}>
                <TeamSMSAssigned />
              </span>
            </Grid>
          ) : (
            <Grid
              item
              xs={4}
              onClick={() => handleClick(user)}
              data-testid="PlatformAdminUI-TableHeader-ToolTip"
            >
              <Tooltip
                placement="top"
                title={
                  <Typography variant="caption">Enable Message Pro</Typography>
                }
              >
                <span>
                  <TeamSMSAdd />
                </span>
              </Tooltip>
            </Grid>
          ))}
      </Grid>
    </div>
  );
};
